<ng-container *ngIf="text">
  <i class="fas fa-info-circle"></i>

  <cpb-tooltip [position]="position">
    <p class="text-tooltip" [innerHTML]="text"></p>
  </cpb-tooltip>
</ng-container>
